/* Sticker Select — global UI: drawers, cart, popup, announcement, reveal. ~vanilla, no deps. */
(() => {
  'use strict';
  const SS = (window.SS = window.SS || {});
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])';

  SS.toast = (msg, type) => {
    const region = $('[data-toast-region]'); if (!region) return;
    const t = document.createElement('div'); t.className = 'toast' + (type === 'error' ? ' toast--error' : ''); t.textContent = msg;
    region.appendChild(t); setTimeout(() => t.remove(), 4000);
  };

  /* ---------- Drawers (menu, cart) with focus trap ---------- */
  let lastFocus = null;
  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('scroll-lock');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const panel = $('.drawer__panel', drawer);
    setTimeout(() => ($(FOCUSABLE, panel) || panel).focus(), 50);
  }
  function closeDrawer(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('scroll-lock');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus) lastFocus.focus();
  }
  SS.openCart = () => openDrawer($('[data-cart-drawer]'));
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.dataset.drawerOpen)); return; }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { closeDrawer(closer.closest('[data-drawer]')); return; }
    const cartLink = e.target.closest('[data-cart-open]');
    if (cartLink && $('[data-cart-drawer]') && !document.body.classList.contains('template-cart')) { e.preventDefault(); SS.openCart(); }
    // close desktop dropdowns on outside click
    $$('[data-dropdown][open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', (e) => {
    const open = $('[data-drawer].is-open');
    if (!open) { if (e.key === 'Escape') $$('[data-dropdown][open]').forEach((d) => d.removeAttribute('open')); return; }
    if (e.key === 'Escape') closeDrawer(open);
    if (e.key === 'Tab') {
      const items = $$(FOCUSABLE, $('.drawer__panel', open)).filter((el) => el.offsetParent !== null);
      if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Cart: section re-rendering ---------- */
  const cartSectionIds = () => $$('[data-cart-section]').map((el) => el.dataset.cartSection);
  function applySections(sections) {
    if (!sections) return;
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector(`[data-cart-section="${id}"]`);
      const current = document.querySelector(`[data-cart-section="${id}"]`);
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      if (id === 'cart-drawer') {
        const title = doc.querySelector('#CartDrawerTitle'); const curTitle = $('#CartDrawerTitle');
        if (title && curTitle) curTitle.innerHTML = title.innerHTML;
      }
    });
  }
  async function refreshCount() {
    try {
      const cart = await (await fetch(`${SS.routes.cart}.js`, { headers: { Accept: 'application/json' } })).json();
      $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count || ''; el.dataset.count = cart.item_count; });
      return cart;
    } catch (e) { return null; }
  }
  async function changeLine(key, quantity) {
    const ids = cartSectionIds();
    const res = await fetch(`${SS.routes.cartChange}.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity, sections: ids.join(','), sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (!res.ok || data.status) { SS.toast(data.description || data.message || 'Could not update cart', 'error'); return; }
    applySections(data.sections);
    $$('[data-cart-count]').forEach((el) => { el.textContent = data.item_count || ''; el.dataset.count = data.item_count; });
  }
  async function rerenderCart() {
    const ids = cartSectionIds(); if (!ids.length) return;
    const res = await fetch(`${window.location.pathname}?sections=${ids.join(',')}`);
    if (res.ok) applySections(await res.json());
    refreshCount();
  }
  SS.rerenderCart = rerenderCart;

  document.addEventListener('cart:updated', (e) => {
    const d = e.detail || {};
    if (d.sections) applySections(d.sections); else rerenderCart();
    refreshCount();
    if (d.open) { if ($('[data-cart-drawer]')) SS.openCart(); else window.location.href = SS.routes.cart; }
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-change]');
    if (!b) return;
    e.preventDefault();
    b.closest('.cart-item')?.style.setProperty('opacity', '.5');
    changeLine(b.dataset.qtyChange, Math.max(0, parseInt(b.dataset.qty, 10) || 0));
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-qty-input]')) changeLine(e.target.dataset.qtyInput, Math.max(0, parseInt(e.target.value, 10) || 0));
    if (e.target.matches('[data-cart-note]')) fetch(`${SS.routes.cartUpdate}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: e.target.value }) });
  });

  /* ---------- Proof submission (no payment) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-proof-submit]');
    if (!form) return;
    e.preventDefault();
    const err = $('[data-proof-submit-error]', form);
    const btn = $('button[type=submit]', form);
    const email = form.email.value.trim();
    err.hidden = true;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.textContent = 'Please enter a valid email so we can send your proof.'; err.hidden = false; form.email.setAttribute('aria-invalid', 'true'); form.email.focus(); return; }
    form.email.removeAttribute('aria-invalid');
    btn.classList.add('is-loading'); btn.disabled = true;
    try {
      const cart = await (await fetch(`${SS.routes.cart}.js`, { headers: { Accept: 'application/json' } })).json();
      const lines = cart.items.filter((i) => i.properties && i.properties._proof === 'required');
      if (!lines.length) throw new Error('No proof items in your cart.');
      const res = await fetch(`${SS.backend}/proof-request`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          email, name: form.name ? form.name.value.trim() : '', note: cart.note || '',
          lines: lines.map((i) => ({ variant_id: i.variant_id, quantity: i.quantity, properties: i.properties }))
        })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.ok) throw new Error(data.error || 'We couldn’t submit your proof request. Please try again.');
      const updates = {}; lines.forEach((i) => { updates[i.key] = 0; });
      await fetch(`${SS.routes.cartUpdate}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
      if (window.SS.track) SS.track('sticker_proof_requested', { request: data.reference, lines: lines.length });
      await rerenderCart();
      $$('[data-proof-success]').forEach((box) => {
        box.innerHTML = `<strong>Proof request ${data.reference} received!</strong><br>We'll email your proof to ${email.replace(/[<>&"]/g, '')}. Nothing has been charged.`;
        box.hidden = false;
      });
      ($('[data-cart-drawer].is-open [data-proof-success]') || $('[data-proof-success]'))?.focus();
    } catch (ex) {
      err.textContent = ex.message; err.hidden = false;
    } finally { btn.classList.remove('is-loading'); btn.disabled = false; }
  });

  /* ---------- Email popup (native customer form, AJAX) ---------- */
  function initPopup() {
    const dlg = $('[data-email-popup]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    const KEY = 'ss_popup_dismissed';
    const days = parseInt(dlg.dataset.days, 10) || 14;
    let dismissed = 0;
    try { dismissed = parseInt(localStorage.getItem(KEY) || '0', 10); } catch (e) { /* ignore */ }
    const show = () => { if (!dlg.open && !$('[data-drawer].is-open')) { dlg.showModal(); } };
    const remember = () => { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) { /* ignore */ } };
    const isEditor = window.Shopify && Shopify.designMode;
    if (!isEditor && Date.now() - dismissed > days * 864e5 && !/customer_posted=true/.test(location.search)) {
      setTimeout(show, (parseInt(dlg.dataset.delay, 10) || 8) * 1000);
    }
    // links to #EmailPopup open it anytime
    document.addEventListener('click', (e) => { const a = e.target.closest('a[href$="#EmailPopup"]'); if (a) { e.preventDefault(); show(); } });
    dlg.addEventListener('close', remember);
    dlg.addEventListener('click', (e) => { if (e.target === dlg || e.target.closest('[data-modal-close]')) dlg.close(); });
    const form = $('[data-popup-form]', dlg) || $('form', dlg);
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = form.querySelector('[type=email]');
      const err = $('#EmailPopupError', dlg);
      if (!email.checkValidity()) { err.textContent = 'Please enter a valid email address.'; err.hidden = false; email.setAttribute('aria-invalid', 'true'); email.focus(); return; }
      const btn = $('button[type=submit]', form); btn.classList.add('is-loading'); btn.disabled = true;
      try {
        const res = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } });
        if (/\/challenge/.test(res.url)) { form.submit(); return; } // Shopify bot check → let the browser handle it
        if (/customer_posted=true/.test(res.url)) {
          $('[data-popup-fields]', dlg).hidden = true; const ok = $('[data-popup-success]', dlg); ok.hidden = false; ok.focus();
          remember(); SS.track && SS.track('sticker_email_signup', { source: 'popup' });
        } else throw new Error();
      } catch (ex) {
        err.textContent = 'Something went wrong. Please try again.'; err.hidden = false;
      } finally { btn.classList.remove('is-loading'); btn.disabled = false; }
    });
  }

  /* ---------- Announcement rotator ---------- */
  function initRotator() {
    $$('[data-rotator]').forEach((r) => {
      const items = $$('.announcement__item', r); if (items.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let i = 0; const ms = (parseInt(r.dataset.interval, 10) || 5) * 1000;
      let timer = setInterval(next, ms);
      function next() { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }
      r.addEventListener('mouseenter', () => clearInterval(timer));
      r.addEventListener('mouseleave', () => { timer = setInterval(next, ms); });
    });
  }

  /* ---------- Header shadow + reveal ---------- */
  function initHeader() {
    const h = $('[data-header]'); if (!h) return;
    const on = () => h.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', on, { passive: true }); on();
  }
  function initReveal() {
    const els = $$('.reveal'); if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-visible')); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    els.forEach((e) => io.observe(e));
  }

  /* ---------- FAQ: single-open option ---------- */
  document.addEventListener('toggle', (e) => {
    const d = e.target; if (!(d instanceof HTMLDetailsElement) || !d.open) return;
    const group = d.closest('[data-accordion-single]');
    if (group) $$('details[open]', group).forEach((o) => { if (o !== d) o.open = false; });
  }, true);

  const ready = () => { initPopup(); initRotator(); initHeader(); initReveal(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
  document.addEventListener('shopify:section:load', () => { initReveal(); initRotator(); });
})();
